import comp from "./Bifurcation";
export default comp;
